import { ErrorMessages } from '@types';
import { ZodError } from 'zod';

type InlineErrorMessageProps = {
  path: string | undefined;
  messages: ZodError | ErrorMessages[] | undefined;
};

export const InlineErrorMessage: React.FC<InlineErrorMessageProps> = (
  props,
) => {
  const { path = '', messages } = props;

  let errorMessage = '';
  let error;
  if (messages instanceof ZodError) {
    error = messages.issues.find((issue) => issue.path.includes(path));
  }

  if (messages instanceof Array) {
    error = messages.find((message) => message.path.includes(path));
  }

  errorMessage = error?.message || '';

  return errorMessage ? (
    <div
      id={path}
      data-testid="inline-error-message"
      className="text-status-error text-body border-l-sm mb-2 mt-2 border-current pl-2 font-bold"
    >
      {errorMessage}
    </div>
  ) : (
    <></>
  );
};
